import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-log-modal',
  templateUrl: './change-log-modal.component.html',
  styleUrls: ['./change-log-modal.component.css']
})
export class ChangeLogModalComponent implements OnInit {

  changeLog: string = '';
  loading: boolean = true;
  errore: boolean = false;

  constructor(public activeModal: NgbActiveModal, private http: HttpClient) { }

  ngOnInit(): void {
    this.http.get('changelog.txt', { responseType: 'text' }).subscribe({
      next: (contenuto) => {
        this.changeLog = contenuto;
        this.loading = false;
      },
      error: () => {
        this.errore = true;
        this.loading = false;
      }
    });
  }
}
